import { Currency as CurrencyEnum } from '@shared/graphql'

export const getCurrencyItems = (variant: 'fiat' | 'crypto') => {
  return variant === 'fiat' ? getFiatCurrencyItems() : getCryptoCurrencyItems()
}

// Function to get fiat currency items
const getFiatCurrencyItems = () => {
  return [
    {
      label: CurrencyEnum.USD,
      value: CurrencyEnum.USD,
    },
    {
      label: CurrencyEnum.EUR,
      value: CurrencyEnum.EUR,
    },
    {
      label: CurrencyEnum.MXN,
      value: CurrencyEnum.MXN,
    },
    {
      label: CurrencyEnum.BRL,
      value: CurrencyEnum.BRL,
    },
    {
      label: CurrencyEnum.SGD,
      value: CurrencyEnum.SGD,
    },
  ]
}

// Function to get crypto currency items
const getCryptoCurrencyItems = () => {
  return [
    {
      label: CurrencyEnum.USDC,
      value: CurrencyEnum.USD,
    },
    {
      label: CurrencyEnum.EURC,
      value: CurrencyEnum.EUR,
    },
  ]
}
